import {wrap} from '@codeurs/front'
import placeholder from 'assets/images/placeholder.png'
import React from 'react'
import {style} from 'util/style'
import {Blocks} from '../blocks/Blocks'
import {ListItemBlock} from '../blocks/ListBlock'
import {Breadcrumbs} from '../layout/Breadcrumbs'
import {Hero} from '../layout/Hero'
import {Layout} from '../layout/Layout'
import {Theme} from '../Theme'
import {CollaboratorDetailType} from './CollaboratorDetail'
import {FullpageType} from './Fullpage'

const styles = style('collaborator')

type CollaboratorsType = {
	collaborators: CollaboratorDetailType
}

export const Collaborators: React.FC<CollaboratorsType & FullpageType> = wrap(
	Layout
)(({...props}) => {
	const {parents, title, hero, blocks, collaborators} = props
	const hasCollaborators = collaborators && collaborators?.length > 0

	return (
		<div className={styles()}>
			<Hero {...hero} title={(hero && hero.title) || title} />
			<Breadcrumbs parents={parents} title={title} />
			{hasCollaborators && (
				<div className={styles('items')}>
					<Theme.Container>
						{collaborators.map((collaborator) => (
							<CollaboratorsItem key={collaborator?.url} {...collaborator} />
						))}
					</Theme.Container>
				</div>
			)}
			<Blocks blocks={blocks} container={true} />
		</div>
	)
})

const CollaboratorsItem: React.FC<
	CollaboratorDetailType & {url: string; title: string}
> = ({url, image, title, text, email}) => {
	const emailCta = {
		type: 'external' as const,
		url: email ? `mailto:${email}` : null,
		title: email,
		target: '_self' as const
	}

	return (
		<ListItemBlock
			url={url}
			key={title}
			title={title}
			preview_image={image || placeholder}
			preview_text={text}
			cta={emailCta}
		/>
	)
}
